import './Stocks.scss';

import { Col, Form, Row } from 'react-bootstrap';
import {
    LeadingActions,
    SwipeAction,
    SwipeableList,
    SwipeableListItem,
    TrailingActions,
} from 'react-swipeable-list';
import React, { useEffect, useState } from 'react';
import { faAdd, faBoxOpen, faEdit, faFileExcel, faTrash } from '@fortawesome/free-solid-svg-icons';
import { formatInReal, normalizeString } from '../../commons/util/HallAppUtil';

import AppInput from '../../commons/inputs/AppInput';
import AppLoading from '../../commons/AppLoading';
import ConfirmModal from '../../commons/modal/ConfirmModal';
import EmptyState from '../../commons/EmptyState';
import FloatingButton from '../../commons/buttons/FloatingButton';
import FloatingVideoButton from '../../commons/buttons/FloatingVideoButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HallAppToast from '../../commons/HallAppToast';
import HistoryStockModal from './HistoryStockModal';
import ModalProduct from './ModalProducts';
import ModalStock from './ModalStock';
import Nav from 'react-bootstrap/Nav';
import ProductCard from './ProductCard';
import ProductsAPI from './ProductsAPI';
import RegisterStockModal from './RegisterStockModal';
import ReportValues from '../report/components/ReportValues';
import StockAPI from './StockAPI';
import StockCommission from './StockCommission';
import StockCommissionEmployee from './StockCommissionEmployee';
import UserService from '../../auth/UserService';

const stockAPI = new StockAPI();
const userAPI = new UserService();
const productAPI = new ProductsAPI();

function Stocks() {
    const [showModal, setShowModal] = useState(false);
    const [products, setProducts] = useState([]);
    const [productsTmp, setProductsTmp] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [currentProduct, setCurrentProduct] = useState({});
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [isLoadingModalDelete, setIsLoadingModalDelete] = useState(false);

    const [showModalRegister, setShowModalRegister] = useState(false);

    const [showModalHistory, setShowModalHistory] = useState(false);
    const [summaryValues, setSummaryValues] = useState({});
    const [isLoadingSummary, setIsLoadingSummary] = useState(false);


    const [currentTap, setCurrentTab] = useState('PRODUCT');

    useEffect(() => {
        callGetProducts();
        callGetSummary();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function isUserAdmin() {
        const user = userAPI.getUserData();
        return user.rules?.length !== 0 && user.rules?.includes('COMPANY');
    }

    const callGetSummary = async () => {
        try {
            setIsLoadingSummary(true)
            const resp = await stockAPI.getSummary();
            setSummaryValues(resp.data || {});
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoadingSummary(false)
        }
    };

    const callGetProducts = async () => {
        try {
            setIsLoading(true);
            const resp = await stockAPI.getProducts();
            const list = Array.isArray(resp.data) ? resp.data : [];

            // Ordena: primeiro com estoque baixo, depois por qtd crescente
            const sorted = [...list].sort((a, b) => {
                const aLow = a.minStockNotify && a.qtdStock <= a.minStockNotify;
                const bLow = b.minStockNotify && b.qtdStock <= b.minStockNotify;
                if (aLow && !bLow) return -1;
                if (!aLow && bLow) return 1;
                return (a.qtdStock ?? 0) - (b.qtdStock ?? 0);
            });

            setProducts(sorted);
            setProductsTmp(sorted);
        } catch (_) {
            setProducts([]);
            setProductsTmp([]);
        } finally {
            setIsLoading(false);
        }
    };

    function search(value) {
        const normalizedValue = normalizeString(value);
        const results = products.filter((p) => {
            const normalizedName = normalizeString(p.name);
            const normalizedMarkName = normalizeString(p?.mark || '');
            const normalizedInternalCode = normalizeString(p?.internalCode || '');
            return (
                normalizedName.includes(normalizedValue) ||
                normalizedMarkName.includes(normalizedValue) ||
                normalizedInternalCode.includes(normalizedValue)
            );
        });
        setProductsTmp(results);
    }

    const deleteProduct = async () => {
        try {
            setIsLoadingModalDelete(true);
            await stockAPI.deleteProduct(currentProduct?.id);
            HallAppToast.success();
            setCurrentProduct({});
            setShowModalDelete(false);
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoadingModalDelete(false);
            await callGetProducts();
            await callGetSummary();
        }
    };

    const editAction = (data) => (
        <LeadingActions>
            <SwipeAction
                onClick={() => {
                    setCurrentProduct(data);
                    setShowModal(true);
                }}
                aria-label={`Editar ${data?.name}`}
            >
                <div className="swipe">
                    <div className="swipe swipe-edt">
                        <FontAwesomeIcon icon={faEdit} size="lg" />
                        <div>EDITAR</div>
                    </div>
                </div>
            </SwipeAction>
        </LeadingActions>
    );

    const deleteAction = (data) => (
        <TrailingActions>
            <SwipeAction
                destructive={false}
                onClick={() => {
                    setCurrentProduct(data);
                    setShowModalDelete(true);
                }}
                aria-label={`Excluir ${data?.name}`}
            >
                <div className="swipe">
                    <div className="swipe swipe-dlt">
                        <FontAwesomeIcon icon={faTrash} size="lg" />
                        <div>EXCLUIR</div>
                    </div>
                </div>
            </SwipeAction>
        </TrailingActions>
    );

    return (
        <>
            <div className="container">
                <div className={`stocks__tabs ${currentTap === 'COMMISSION' ? 'mt-5' : ''}`}>
                    <Nav variant="underline" defaultActiveKey="/home">
                        <Nav.Item>
                            <Nav.Link
                                onClick={() => setCurrentTab('PRODUCT')}
                                active={currentTap === 'PRODUCT'}
                                eventKey="link-0"
                            >
                                Produtos e Estoque
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            {isUserAdmin() ? (
                                <Nav.Link
                                    onClick={() => setCurrentTab('COMMISSION')}
                                    active={currentTap === 'COMMISSION'}
                                    eventKey="link-1"
                                >
                                    Comissões
                                </Nav.Link>
                            ) : (
                                <Nav.Link
                                    onClick={() => setCurrentTab('COMMISSION_EMPLOYEE')}
                                    active={currentTap === 'COMMISSION_EMPLOYEE'}
                                    eventKey="link-1"
                                >
                                    Minhas Comissões
                                </Nav.Link>
                            )}
                        </Nav.Item>
                    </Nav>
                </div>
            </div>

            {currentTap === 'COMMISSION' && <StockCommission />}
            {currentTap === 'COMMISSION_EMPLOYEE' && <StockCommissionEmployee />}

            {currentTap === 'PRODUCT' && (
                <div>
                    <div className="container">
                        <div className="stocks__summary">
                            <Row className="mb-3">
                                <Col xs={12} md={6}>
                                    <ReportValues
                                        isLoadingSummary={isLoadingSummary}
                                        bgColor="#17a2b8"
                                        value={summaryValues?.qtdProduct || 0}
                                        label="Qtd. produtos em estoque"
                                    />
                                </Col>
                                <Col xs={12} md={6}>
                                    <ReportValues
                                        isLoadingSummary={isLoadingSummary}
                                        bgColor="#eb214e"
                                        value={formatInReal(summaryValues?.totalInvested || 0)}
                                        label="Valor total investido"
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12}>
                                    <ReportValues
                                        isLoadingSummary={isLoadingSummary}
                                        bgColor="#28a745"
                                        value={formatInReal(summaryValues?.grossProfit || 0)}
                                        label="Lucro bruto"
                                    />
                                </Col>
                            </Row>
                        </div>

                        <hr />

                        <Form>
                            <AppInput
                                label="Pesquisar"
                                name="search"
                                errors={{}}
                                onChange={(e) => search(e.target.value)}
                                placeholder="Nome, marca ou código interno"
                            />
                        </Form>

                        <hr />
                        <Row style={{ margin: 0, width: '100%' }}>
                            {isLoading ? (
                                <AppLoading />
                            ) : productsTmp.length === 0 ? (
                                <EmptyState
                                    title="Nenhum produto no estoque ainda"
                                    description="Cadastre seus produtos para controlar níveis de estoque, custos e preços de venda. Você pode começar com um cadastro rápido ou importar uma planilha."
                                    icon={<FontAwesomeIcon icon={faBoxOpen} />}
                                    actionLabel="Cadastrar produto"
                                    onAction={() => setShowModal(true)}
                                />
                            ) : (
                                productsTmp.map((data) => (
                                    <Col xs={12} sm={6} md={4} lg={4} key={data.id} className="mb-3">
                                        <SwipeableList style={{ width: "100%" }}>
                                            <SwipeableListItem
                                                leadingActions={editAction(data)}
                                                trailingActions={deleteAction(data)}
                                                key={data.id}
                                                fullSwipe={false}
                                            >
                                                <div style={{ width: "100%" }}>
                                                    <ProductCard
                                                        data={data}
                                                        setCurrentProduct={setCurrentProduct}
                                                        setShowModalHistory={setShowModalHistory}
                                                        setShowModalRegister={setShowModalRegister}
                                                    />
                                                </div>

                                            </SwipeableListItem>
                                        </SwipeableList>
                                    </Col>
                                ))
                            )}
                        </Row>
                    </div>

                    <FloatingButton
                        icon={faAdd}
                        onClick={() => {
                            setShowModal(true);
                        }}
                        aria-label="Cadastrar produto"
                    />

                    {showModalDelete && (
                        <ConfirmModal
                            show={showModalDelete}
                            title="Excluir"
                            isLoading={isLoadingModalDelete}
                            confirm={deleteProduct}
                            closeModal={() => {
                                setShowModalDelete(false);
                                setCurrentProduct({});
                            }}
                        >
                            Deseja remover o produto{' '}
                            <span style={{ fontWeight: 'bold' }}>{currentProduct?.name}</span>?
                        </ConfirmModal>
                    )}

                    {showModal && (
                        <ModalProduct
                            show={showModal}
                            productToEdit={currentProduct}
                            callGetProducts={() => {
                                callGetProducts();
                                callGetSummary();
                            }}
                            closeShow={() => {
                                setShowModal(false);
                                setCurrentProduct({});
                            }}
                        />
                    )}

                    <FloatingVideoButton youtubeUrl={"https://www.youtube.com/embed/5X2RaFREuKA"} />

                    {showModalRegister && (
                        <RegisterStockModal
                            show={showModalRegister}
                            callGetProducts={() => {
                                callGetProducts();
                                callGetSummary();
                            }}
                            productToEdit={currentProduct}
                            closeShow={() => {
                                setShowModalRegister(false);
                                setCurrentProduct({});
                            }}
                        />
                    )}

                    {showModalHistory && (
                        <HistoryStockModal
                            show={showModalHistory}
                            product={currentProduct}
                            callUpdate={() => {
                                callGetProducts();
                                callGetSummary();
                            }}
                            closeShow={() => {
                                setShowModalHistory(false);
                                setCurrentProduct({});
                            }}
                        />
                    )}
                </div>
            )}
            <div style={{ height: "calc(50px + 72px)" }}></div>
        </>
    );
}

export default Stocks;